import { am } from './am';
import { en, type MessageKey } from './en';
import { om } from './om';

export type { MessageKey };
export const LANGUAGES = ['am', 'om', 'ti', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = 'am';
export const LANGUAGE_NAMES: Record<Language, string> = { am: 'አማርኛ', om: 'Afaan Oromoo', ti: 'ትግርኛ', en: 'English' };

// Tigrinya, and any key a catalogue lacks, fall back to English.
const catalogues: Record<Language, Partial<Record<MessageKey, string>>> = { am, en, om, ti: {} };

export function isLanguage(v: unknown): v is Language {
  return typeof v === 'string' && (LANGUAGES as readonly string[]).includes(v);
}

export function translate(lang: Language, key: MessageKey, params: Record<string, string | number> = {}): string {
  const template = catalogues[lang][key] ?? en[key];
  return template.replace(/\{(\w+)\}/g, (_, n: string) => String(params[n] ?? `{${n}}`));
}

/** Share of `en` keys translated, for the translation dashboard and tests. */
export function coverage(lang: Language): number {
  const keys = Object.keys(en);
  return keys.filter((k) => catalogues[lang][k as MessageKey]).length / keys.length;
}

/** Ordinal place label: 1st/2nd/3rd in English, 1ኛ/2ኛ/3ኛ in Amharic, 1ffaa/2ffaa in Afaan Oromoo. */
export function place(lang: Language, n: number): string {
  if (lang === 'am') return `${n}ኛ`;
  if (lang === 'om') return `${n}ffaa`;
  return `${n}${['st', 'nd', 'rd'][n - 1] ?? 'th'}`;
}
